/* tslint:disable:typedef-whitespace no-trailing-whitespace no-inferrable-types import-spacing */

import { ElementRef }         from '@angular/core';

import { Dialog }             from './dialog';
import { Logger }             from '@/util/logger';
import { IValidatorCallBack } from './i.validator.call.back';
import { IOkCallBack        } from './i.ok.call.back';

import * as $                 from 'jquery';

/**
 *
 * @class ErrorDialog
 *
 * @brief helper dialog to just show a user that an error has occurred.
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      April 2020
 *
 */
export class ErrorDialog extends Dialog {

  /** standard constructor, allow for partial alert to be given */
  constructor(
    host: ElementRef
  ) {

    super(host);

    this.title     = 'Error!';
    this.icon      = '<i class="fas fa-bomb"></i>';

    Logger.debug('[ErrorDialog] setting up...');

    this.hasOk     = true;
    this.hasCancel = false;
  }

  /** dialog has been opened */
  public open(validator?: IValidatorCallBack, success?: IOkCallBack, options?: any) {

    this.validator = validator ? validator : null;
    this.success   = success   ? success   : null;

    this.hasOk     = true;
    this.hasCancel = false;

    let message: string = '';

    Logger.debug('[ErrorDialog] opening...');

    if (options) {

      if (options.message) {

        message = options.message;
      }
    }

    const body = $(this.host).find('.modal-body');

    const html = `

<div class="gui-error-line">${message}</div>
    `;

    $(body).html(html);


  }

  /** dialog is closing */
  public close() {

    Logger.debug('[ErrorDialog] closing...');
  }

  /** dialog was accepted */
  public ok() {

    Logger.debug('[ErrorDialog] accepted.');

    if (this.success) {

      /* inform the client */

      this.success();
    }

  }
}
